module.exports = __webpack_public_path__ + "static/media/warning-yellow.f2ca9a0b.svg";